/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const findIngestionsFiltersDtoStatusEnum = {
  PENDING: "PENDING",
  ERROR: "ERROR",
  FAILED: "FAILED",
  SUCCESS: "SUCCESS",
} as const

export type FindIngestionsFiltersDtoStatusEnumKey =
  (typeof findIngestionsFiltersDtoStatusEnum)[keyof typeof findIngestionsFiltersDtoStatusEnum]

export const findIngestionsFiltersDtoTypeEnum = {
  PRODUCT: "PRODUCT",
  BUSINESS_PARTNER: "BUSINESS_PARTNER",
} as const

export type FindIngestionsFiltersDtoTypeEnumKey =
  (typeof findIngestionsFiltersDtoTypeEnum)[keyof typeof findIngestionsFiltersDtoTypeEnum]

export type FindIngestionsFiltersDto = {
  /**
   * @type string | undefined
   */
  status?: FindIngestionsFiltersDtoStatusEnumKey
  /**
   * @type string | undefined
   */
  userEmail?: string
  /**
   * @type string | undefined
   */
  createdAt?: string
  /**
   * @type string | undefined
   */
  fileName?: string
  /**
   * @type string | undefined
   */
  type?: FindIngestionsFiltersDtoTypeEnumKey
}
